import React, { useCallback, useEffect, useState } from 'react';
import { Button, TextField, Grid, Typography, Box, TableHead, TableRow, TableCell, TableBody, Table, TableContainer, Paper, FormControl, InputLabel, Select, MenuItem, FormGroup, FormControlLabel, Checkbox, Stack, Divider, List, ListItem, ListItemButton, ListItemText, FormLabel, RadioGroup, Radio, FormHelperText, Tabs, Tab, Dialog, DialogTitle, DialogContent, DialogActions, TableFooter, TablePagination } from '@mui/material';
import jwtAuthAxios from 'app/services/auth/jwtAuth';
import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";
import * as Yup from "yup"
import { Formik, Form, Field, ErrorMessage } from "formik";
import useJumboAuth from '@jumbo/hooks/useJumboAuth';
import { formatDate } from '../accTxn/AccTxn';
import { DatePicker } from '@mui/lab';
import NoDataPlaceholder from 'app/shared/NoDataPlaceholder';

// Define initial values
const btsinitialValues = {
    toBranch: "",
    inventoryType: "",
    itemCode: "",
    narration:''
  };
  // Validation schema using Yup
  const btsvalidationSchema = Yup.object({
    toBranch: Yup.string().required("To Branch is required"),
    inventoryType: Yup.string().required("Inventory Type is required"),
    itemCode: Yup.string().required("Item/Packet Code is required"),
  });
const BranchTransissForm = () => {
    const inventoryOptions = ["POLISH-SINGLE", "POLISH-PARCEL", "JEWELRY"];
    const swal = useSwalWrapper();
    const { authUser } = useJumboAuth()
    const handlesubmit =async (values)=>{
      await jwtAuthAxios.post('transation/branchissue', values).then((data)=>{
        if (data.data.status === "success") {
          swal.fire({
            icon: 'success',
            text: data.data.message,
          });
        } else {
          swal.fire({
            icon: 'error',
            text: 'Something went wrong',
          });
        }
      }).catch(e=>alert(e?.response?.data || e?.message))
      }
  
    return (
      <Formik
        initialValues={btsinitialValues}
        validationSchema={btsvalidationSchema}
        onSubmit={handlesubmit}
      >
        {({ values, touched, errors, handleChange, handleBlur }) => (
          <Form>
            {/* From Branch (disabled) */}
            <Grid container spacing={3}>
              <Grid item lg={4}>
                <FormControl size='small' fullWidth margin="normal"><Field
                  name="fromBranch"
                  render={({ field }) => (
                    <TextField
                      {...field}
                      label="From Branch"
                      variant="outlined"
                      fullWidth
                      size='small'
                      disabled
                      value={authUser?.currentBranch?.FL_BRANCH_NAME} // Disabled, static value
                      error={touched.fromBranch && Boolean(errors.fromBranch)}
                      helperText={touched.fromBranch && errors.fromBranch}
                    />
                  )}
                /></FormControl>
              </Grid>
              <Grid item lg={4}>
                {/* To Branch */}
                <FormControl size='small' fullWidth margin="normal">
                  <InputLabel>To Branch</InputLabel>
                  <Select
                    label="To Branch"
                    name="toBranch"
                    size='small'
                    value={values.toBranch}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.toBranch && Boolean(errors.toBranch)}
                  >
                    {authUser?.branches?.map((branch, index) => (
                      <MenuItem disabled={branch?.FL_BRANCH_CODE == authUser?.currentBranch?.FL_BRANCH_CODE} key={index} value={branch?.FL_BRANCH_CODE}>
                        {branch?.FL_BRANCH_NAME}
                      </MenuItem>
                    ))}
                  </Select>
                  {touched.toBranch && errors.toBranch && (
                    <FormHelperText error>{errors.toBranch}</FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item lg={4}>
                {/* Inventory Type */}
                <FormControl size='small' fullWidth margin="normal">
                  <InputLabel>Inventory Type</InputLabel>
                  <Select
                    label="Inventory Type"
  
                    name="inventoryType"
                    value={values.inventoryType}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.inventoryType && Boolean(errors.inventoryType)}
                  >
                    {inventoryOptions.map((type, index) => (
                      <MenuItem disabled={type =='POLISH-PARCEL'} key={index} value={type}>{type}
                      </MenuItem>
                    ))}
                  </Select>
                  {touched.inventoryType && errors.inventoryType && (
                    <FormHelperText error>{errors.inventoryType}</FormHelperText>
                  )}
                </FormControl>
              </Grid>
            </Grid>
            {/* Item Code */}
            <Field
              name="itemCode"
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Item/Packet Codes Should Be Space or Coma(',') Seprated"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  multiline // This makes it a textarea
                  rows={4} // You can adjust the number of rows as per your design
                  error={touched.itemCode && Boolean(errors.itemCode)}
                  helperText={touched.itemCode && errors.itemCode}
                />
              )}
            />
            <Field
              name="narration"
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Narration"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  multiline // This makes it a textarea
                  rows={2} // You can adjust the number of rows as per your design
                />
              )}
            />
  
            {/* Submit Button */}
            <Button type="submit" variant="contained" color="primary" fullWidth>
              Submit
            </Button>
          </Form>
        )}
      </Formik>
    );
  }
//   const BranchTransres = () => {
//     const [rows, setRows] = useState([]);
//     const [open, setOpen] = useState(false);
//     const [details, setDetails] = useState([]);
//     const [selected, setSelected] = useState({});
//     const Swal = useSwalWrapper();
//     // Fetch initial data
//     useEffect(() => {
//       const fetchData = async () => {
//         try {
//           const response = await jwtAuthAxios.get("/transation/branchrec");
//           if (response.data.status === "success") {
//             setRows(response.data.data);
//           } else {
//             Swal.fire("Error", "Unable to fetch data", "error");
//           }
//         } catch (error) {
//           Swal.fire("Error", error?.response?.data || error.message, "error");
//         }
//       };
//       fetchData();
//     }, []);
  
//     // Open dialog and fetch details
//     const handleShowDetails = async (trno, type) => {
//       try {
//         const response = await jwtAuthAxios.get("/transation/branchrec", { params: { trno, type } });
//         if (response.data.status === "success") {
//           setDetails(response.data.data);
//           setSelected({ trno, type });
//           setOpen(true);
//         } else {
//           Swal.fire("Error", "Unable to fetch details", "error");
//         }
//       } catch (error) {
//         Swal.fire("Error", error?.response?.data || error.message, "error");
//       }
//     };
  
//     // Handle API call for action
//     const handleAction = async () => {
//       try {
//         const response = await jwtAuthAxios.post("/transation/branchrec", selected);
//         if (response.data.status === "success") {
//           Swal.fire("Success", response.data.message, "success");
//         } else {
//           Swal.fire("Error", "Something went wrong", "error");
//         }
//       } catch (error) {
//         Swal.fire("Error", error?.response?.data || error.message, "error");
//       }
//     };
  
//     return (
//       <div>
//         <TableContainer component={Paper}>
//           <Table>
//             <TableHead>
//               <TableRow>
//                 <TableCell>Transaction No</TableCell>
//                 <TableCell>Branch</TableCell>
//                 <TableCell>Inventory Type</TableCell>
//                 <TableCell>Rate</TableCell>
//                 <TableCell>Discount</TableCell>
//                 <TableCell>Amount</TableCell>
//                 <TableCell>Date</TableCell>
//                 <TableCell>Actions</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {rows.map((row, index) => (
//                 <TableRow key={index}>
//                   <TableCell>{row.FL_TRANS_NO}</TableCell>
//                   <TableCell>{row.FL_BRID}</TableCell>
//                   <TableCell>{row.FL_INVENTORY_TYPE}</TableCell>
//                   <TableCell>{row.RATE}</TableCell>
//                   <TableCell>{row.DISC}</TableCell>
//                   <TableCell>{row.AMT}</TableCell>
//                   <TableCell>{formatDate(row.TDATE)}</TableCell>
//                   <TableCell>
//                     <Button
//                       variant="outlined"
//                       color="primary"
//                       onClick={() => handleShowDetails(row.FL_TRANS_NO, row.FL_TRANS_TYPE)}
//                     >
//                       Show Details
//                     </Button>
//                     <Button
//                       variant="contained"
//                       color="secondary"
//                       onClick={handleAction}
//                     >
//                       Action
//                     </Button>
//                   </TableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </TableContainer>
  
//         <Dialog open={open} onClose={() => setOpen(false)}>
//           <DialogTitle>Item Details</DialogTitle>
//           <DialogContent>
//             <Table border={1} size='small'>
//               <TableHead>
//                 <TableRow>
//                   <TableCell>Lot Id</TableCell>
//                   <TableCell>Rate</TableCell>
//                   <TableCell>Disc</TableCell>
//                   <TableCell>Amt</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {details.map((detail, index) => (
//                   <TableRow key={index}>
//                     <TableCell>{detail.FL_LOT_ID}</TableCell>
//                     <TableCell>{detail.FL_RATE?.toFixed(2)}</TableCell>
//                     <TableCell>{detail.FL_DISC?.toFixed(2)}</TableCell>
//                     <TableCell>{detail.FL_AMT1?.toFixed(2)}</TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={() => setOpen(false)}>Close</Button>
//           </DialogActions>
//         </Dialog>
//       </div>
//     );
//   };

const BranchTransres = () => {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [details, setDetails] = useState([]);
  const [selected, setSelected] = useState({});
  const [date, setDate] = useState(null);
const Swal=useSwalWrapper()
  // Fetch initial data
  const fetchData = useCallback(async () => {
    try {
      const response = await jwtAuthAxios.get("/transation/branchrec");
      if (response.data.status === "success") {
        setRows(response.data.data);
      } else {
        Swal.fire("Error", "Unable to fetch data", "error");
      }
    } catch (error) {
      Swal.fire("Error", error?.response?.data || error.message, "error");
    }
  },[]);
  useEffect(() => {
    fetchData();
  }, []);

  // Open dialog and fetch details
  const handleShowDetails = async (row) => {
    try {
      const response = await jwtAuthAxios.get("/transation/branchrec", { params: {trno: row.FL_TRANS_NO, type:row.FL_TRANS_TYPE } });
      if (response.data.status === "success") {
        setDetails(response.data.data);
        setSelected({ trno:row.FL_TRANS_NO, type:row.FL_TRANS_TYPE,...row });
        setDate(null); // Reset date
        setOpen(true);
      } else {
        Swal.fire("Error", "Unable to fetch details", "error");
      }
    } catch (error) {
      Swal.fire("Error", error?.response?.data || error.message, "error");
    }
  };

  // Handle API call for action
  const handleAction = async () => {
    if (!date || !selected.FL_INVENTORY_TYPE) {
      Swal.fire("Error", "Please select a date and inventory type.", "error");
      return;
    }

    try {
      const response = await jwtAuthAxios.post("/transation/branchrec", {
        ...selected,
        date: date, // Format date as YYYY-MM-DD
        inventoryType:selected.FL_INVENTORY_TYPE,
      });

      if (response.data.status === "success") {
        Swal.fire("Success", response.data.message, "success");
        fetchData();
        setOpen(false);
      } else {
        Swal.fire("Error", "Something went wrong", "error");
      }
    } catch (error) {
      Swal.fire("Error", error?.response?.data || error.message, "error");
    }
  };

  return (
    <div>
      <TableContainer component={Paper}>
        {rows?.length > 0 ?
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Transaction No</TableCell>
              <TableCell>Branch</TableCell>
              <TableCell>Inventory Type</TableCell>
              <TableCell>Rate</TableCell>
              <TableCell>Discount</TableCell>
              <TableCell>Amount</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <TableRow key={index}>
                <TableCell>{row.FL_TRANS_NO}</TableCell>
                <TableCell>{row.FL_BRID}</TableCell>
                <TableCell>{row.FL_INVENTORY_TYPE}</TableCell>
                <TableCell>{row.RATE}</TableCell>
                <TableCell>{row.DISC}</TableCell>
                <TableCell>{row.AMT}</TableCell>
                <TableCell>{row.TDATE}</TableCell>
                <TableCell>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => handleShowDetails(row)}
                  >
                    Show Details
                  </Button>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
        </Table>:<NoDataPlaceholder/>}
      </TableContainer>

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Item Details</DialogTitle>
        <DialogContent>
          <Table border={1} size="small">
            <TableHead>
              <TableRow>
                <TableCell>Lot Id</TableCell>
                <TableCell>Rate</TableCell>
                <TableCell>Disc</TableCell>
                <TableCell>Amt</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {details.map((detail, index) => (
                <TableRow key={index}>
                  <TableCell>{detail.FL_LOT_ID}</TableCell>
                  <TableCell>{detail.FL_RATE?.toFixed(2)}</TableCell>
                  <TableCell>{detail.FL_DISC?.toFixed(2)}</TableCell>
                  <TableCell>{detail.FL_AMT1?.toFixed(2)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
           
          <TableFooter>
                <TableRow>
                <TableCell>{selected.PCS}</TableCell>
                  <TableCell>{selected.RATE?.toFixed(2)}</TableCell>
                  <TableCell>{selected.DISC?.toFixed(2)}</TableCell>
                  <TableCell>{selected.AMT?.toFixed(2)}</TableCell>
                </TableRow>
          </TableFooter>
          </Table>
          <div style={{ marginTop: 16 }}>
          <TextField
              label="Select Date"
              value={date}
              type='date'
              onChange={(e) => setDate(e.target.value)}
              fullWidth
            />
          </div>
          
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Close</Button>
          <Button variant="contained" color="secondary" onClick={handleAction}>
            Action
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};


  const HistoryTable = () => {
    const [data, setData] = useState([]);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
  
    useEffect(() => {
      fetchHistory();
    }, [page, pageSize]);
  
    const fetchHistory = async () => {
      try {
        const response = await jwtAuthAxios.get('transation/branchhistory', {
          params: {
            page: page + 1,
            pageSize,
          },
        });
        const { data, pagination } = response.data;
        setData(data);
        setTotalRecords(pagination.totalRecords);
      } catch (error) {
        console.error('Error fetching history:', error);
      }
    };
  
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
  
    const handleChangePageSize = (event) => {
      setPageSize(parseInt(event.target.value, 10));
      setPage(0);
    };
  
    return (
      <Paper>
        <TableContainer>
          <Table border={1} size='small'>
            <TableHead>
              <TableRow>
              <TableCell>PCS</TableCell>
              <TableCell>Transaction Type</TableCell>
              <TableCell>Transaction No</TableCell>
              <TableCell>Inventory Type</TableCell>
              <TableCell>Rate</TableCell>
              <TableCell>Discount</TableCell>
              <TableCell>Amount</TableCell>
              <TableCell>Transaction Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
            {data.map((row, index) => (
              <TableRow key={index}>
                <TableCell>{row.PCS}</TableCell>
                <TableCell>{row.FL_TRANS_TYPE}</TableCell>
                <TableCell>{row.FL_TRANS_NO}</TableCell>
                <TableCell>{row.FL_INVENTORY_TYPE}</TableCell>
                <TableCell>{row.RATE.toFixed(2)}</TableCell>
                <TableCell>{row.DISC.toFixed(2)}</TableCell>
                <TableCell>{row.AMT.toFixed(2)}</TableCell>
                <TableCell>{formatDate(row.TDATE)}</TableCell>
              </TableRow>
            ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={totalRecords}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={pageSize}
          onRowsPerPageChange={handleChangePageSize}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </Paper>
    );
  };
  const BranchTabs = () => {
    const [activeTab, setActiveTab] = useState(0);
  
    // Handle tab change
    const handleTabChange = (event, newValue) => {
      setActiveTab(newValue);
    };
  
    return (
      <Box sx={{ width: "100%" }}>
        {/* Tabs */}
        <Tabs value={activeTab}  onChange={handleTabChange} >
          <Tab label="Branch History" />
          <Tab label="Branch Issue" />
          <Tab label="Branch Receive" />
        </Tabs>
  
        {/* Tab Panels */}
        <Box sx={{ mt: 3 }}>
          {activeTab === 0 && (
            <TabPanel>
              <HistoryTable />
            </TabPanel>
          )}
          {activeTab === 1 && (
            <TabPanel>
              
              <BranchTransissForm
              />
            </TabPanel>
          )}
          {activeTab === 2 && (
            <TabPanel>
              <BranchTransres />
            </TabPanel>
          )}
        </Box>
      </Box>
    );
  };
  
  const TabPanel = ({ children }) => {
    return <Box>{children}</Box>;
  };
  
  export default BranchTabs;